if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.activeOverlaySources = new Set();
        this.mql = window.matchMedia('(min-width: 1024px)');
        this.header = document.querySelector('.header-wrapper');
        this.footer = document.querySelector('.tw-arn-footer');
        this.clickOutsideHandler = null; // Store reference to the click outside handler
        this.popupClickOutsideHandler = null; // Store reference to the popup click outside handler
        this.elements = {
          localeInput: this.querySelector('input[name="locale_code"]'),
          countryInput: this.querySelector('input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
          localizationPopup: this.querySelector('.localization-popup'),
          closePopupButton: this.querySelector('#closePopup'),
          overlay: this.querySelector('.arn-country-selector-overlay')
        };

        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.elements.button.addEventListener('click', this.openSelector.bind(this));

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }

        if (this.elements.overlay) {
          this.elements.overlay.addEventListener('click', this.hidePanel.bind(this));
        }

        if (this.footer && this.footer.contains(this.elements.localizationPopup)) {
          this.footer.parentElement.insertBefore(this.elements.localizationPopup, this.footer.nextSibling);
        }
        if (this.elements.localizationPopup) {
          this.updateLocalization();
        }
        if (this.elements.closePopupButton) {
          this.elements.closePopupButton.addEventListener('click', this.hidePopup.bind(this));
        }

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
        document.querySelector('.menu-drawer').classList.remove('country-selector-open');
        this.header.preventHide = false;
        this.hideArnOverlay('panel');
        
        // Remove the click outside listener when panel is closed
        if (this.clickOutsideHandler) {
          document.removeEventListener('click', this.clickOutsideHandler);
          this.clickOutsideHandler = null;
        }
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
            this.openSelector();
            break;
        }
      }

      onItemClick(event) {
        event.preventDefault();
        const country = event.currentTarget.dataset.country;
        const locale = event.currentTarget.dataset.locale;
        
        if (country === 'int' && locale === 'en') {
          window.location.href = '/en-int';
          return;
        }
        
        const form = this.querySelector('form');
        if (form) {
          this.elements.countryInput.value = country;
          this.elements.localeInput.value = locale;
          form.submit();
        }
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );

        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.hasAttribute('data-prevent-hide')) {
          this.header.preventHide = true;
        }
        document.querySelector('.menu-drawer').classList.add('country-selector-open');

        if (this.footer && this.footer.contains(this.elements.panel)) {
          this.footer.parentElement.insertBefore(this.elements.panel, this.footer.nextSibling);
        }

        this.showArnOverlay('panel');

        // Remove any existing click outside listener before adding a new one
        if (this.clickOutsideHandler) {
          document.removeEventListener('click', this.clickOutsideHandler);
        }

        // Create and store the click outside handler
        this.clickOutsideHandler = (event) => {
          if (!this.elements.panel.contains(event.target) && !this.elements.button.contains(event.target)) {
            this.hidePanel();
          }
        };

        // Add listener with a small delay to prevent immediate triggering from the same click that opened the panel
        setTimeout(() => {
          document.addEventListener('click', this.clickOutsideHandler);
        }, 0);
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = allCountries.length;

        this.elements.resetButton.classList.toggle('hidden', !searchValue);

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', searchValue);
        }

        allCountries.forEach((item) => {
          const countryName = this.normalizeString(item.querySelector('.country').textContent);
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden');
            visibleCountries++;
          } else {
            item.parentElement.classList.add('hidden');
            visibleCountries--;
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries
          );
        }

        this.querySelector('.country-selector').scrollTop = 0;
        this.querySelector('.country-selector__list').scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }

      hidePopup() {
        this.elements.localizationPopup.setAttribute('hidden', true);
        this.hideArnOverlay('popup');
        
        // Remove the click outside listener when popup is closed
        if (this.popupClickOutsideHandler) {
          document.removeEventListener('click', this.popupClickOutsideHandler);
          this.popupClickOutsideHandler = null;
        }
      }

      showPopup() {
        this.elements.localizationPopup.removeAttribute('hidden');
        this.showArnOverlay('popup');
        
        // Remove any existing click outside listener before adding a new one
        if (this.popupClickOutsideHandler) {
          document.removeEventListener('click', this.popupClickOutsideHandler);
        }

        // Create and store the click outside handler for popup
        this.popupClickOutsideHandler = (event) => {
          if (
            !this.elements.localizationPopup.contains(event.target) &&
            !this.elements.closePopupButton.contains(event.target)
          ) {
            this.hidePopup();
          }
        };

        // Add listener with a small delay to prevent immediate triggering
        setTimeout(() => {
          document.addEventListener('click', this.popupClickOutsideHandler);
        }, 0);
      }

      isCountryInInternationalMarket(countryCode) {
        const specificMarketCountries = Array.from(this.querySelectorAll('a[data-country]'))
          .map(link => link.dataset.country)
          .filter(country => country !== 'int');
        return !specificMarketCountries.includes(countryCode.toLowerCase());
      }

      isCurrentSiteInternational() {
        return window.location.pathname.includes('-int');
      }

      updateLocalization() {
        if (sessionStorage.getItem('localizationUpdated')) return;

        fetch(
          window.Shopify.routes.root
          + 'browsing_context_suggestions.json'
          + '?country[enabled]=true'
          + '&language[enabled]=true'
        )
          .then(response => response.json())
          .then(data => {
            const detectedCountry = data.detected_values.country.name;
            const countryIsoCode = data.detected_values.country.handle.toLowerCase();
            const detectedLocale = data.suggestions[0].parts.country.handle;
            const userLocation = this.elements.localizationPopup.querySelector('.userLocation');
            const selectedLocation = this.elements.localizationPopup.querySelector('.selectedLocation');
            const popupLink = userLocation.querySelector('a');
            
            const isDetectedCountryInternational = this.isCountryInInternationalMarket(countryIsoCode);
            const isCurrentSiteInternational = this.isCurrentSiteInternational();
            
            if (isDetectedCountryInternational) {
              popupLink.setAttribute('id', 'int');
              popupLink.setAttribute('data-country', 'int');
              popupLink.setAttribute('data-locale', 'en');
              
              const userCountryNames = document.querySelectorAll('.userCountryName');
              userCountryNames.forEach((userCountryName) => {
                userCountryName.textContent = 'International';
              });
            } else {
              popupLink.setAttribute('id', countryIsoCode);
              popupLink.setAttribute('data-locale', detectedLocale);
              popupLink.setAttribute('data-country', countryIsoCode);

              const detectedCountryFlag = userLocation.querySelector('img');
              if (detectedCountryFlag) {
                detectedCountryFlag.src = detectedCountryFlag.src.replace(/arn-flag-\w+\.png/, `arn-flag-${countryIsoCode}.png`);
                detectedCountryFlag.setAttribute('alt', `${detectedCountry} Flag`);
              }
              
              const userCountryNames = document.querySelectorAll('.userCountryName');
              userCountryNames.forEach((userCountryName) => {
                userCountryName.textContent = detectedCountry;
              });
            }

            if (isCurrentSiteInternational) {
              const selectedLink = selectedLocation.querySelector('a');
              selectedLink.setAttribute('id', 'int');
              selectedLink.setAttribute('data-country', 'int');
              selectedLink.setAttribute('data-locale', 'en');
              
              const selectedText = selectedLocation.querySelector('span:last-child');
              if (selectedText) {
                selectedText.textContent = 'International';
              }
            }

            let currentId = isCurrentSiteInternational ? 'int' : selectedLocation.querySelector('a').id;
            let detectedId = isDetectedCountryInternational ? 'int' : countryIsoCode;

            if (currentId !== detectedId) {
              this.showPopup();
              this.elements.localizationPopup.querySelectorAll('a').forEach((item) => 
                item.addEventListener('click', this.onItemClick.bind(this))
              );
              sessionStorage.setItem('localizationUpdated', 'true');
            }
          })
          .catch(error => {
            console.error('Error fetching data:', error);
          });
      }

      showArnOverlay(source) {
        this.activeOverlaySources.add(source);
        if (this.elements.overlay) {
          this.elements.overlay.classList.add('active');
          document.body.classList.add('tw-overflow-hidden');
        }
      }

      hideArnOverlay(source) {
        this.activeOverlaySources.delete(source);
        if (this.activeOverlaySources.size === 0 && this.elements.overlay) {
          this.elements.overlay.classList.remove('active');
          document.body.classList.remove('tw-overflow-hidden');
        }
      }
    }
  );
}